/** Disable page scroll and hide leaderboard (called when leaving main menu) */
export function disableMenuScroll(): void {
  (window as any).__menuScrollEnabled = false;
  window.scrollTo(0, 0);
  const lbSection = document.getElementById('leaderboard-section');
  const scrollHint = document.getElementById('scroll-hint');
  const userProfile = document.getElementById('user-profile');
  if (lbSection) lbSection.style.display = 'none';
  if (scrollHint) scrollHint.classList.remove('on-main-menu');
  // Hide the wallet pill while in the arena — it's menu-only chrome and
  // overlaps the HUD. We only hide it if the user was actually logged in
  // (display !== 'none'); otherwise leave the inline style alone so the
  // logged-out state is preserved.
  if (userProfile && userProfile.style.display !== 'none') {
    userProfile.dataset.hiddenForGameplay = '1';
    userProfile.style.display = 'none';
  }
  // Lock the page hard. Some browsers scroll <html> not <body>, and a
  // fixed-position body is the only reliable cross-browser way to kill
  // any sub-pixel canvas overflow during gameplay.
  document.documentElement.style.overflow = 'hidden';
  document.body.style.overflow = 'hidden';
  document.body.style.height = '100vh';
}

/** Re-enable scroll + show leaderboard (called when returning to main menu) */
export function enableMenuScroll(): void {
  (window as any).__menuScrollEnabled = true;
  const lbSection = document.getElementById('leaderboard-section');
  const scrollHint = document.getElementById('scroll-hint');
  const userProfile = document.getElementById('user-profile');
  if (lbSection) lbSection.style.display = '';
  if (scrollHint) {
    scrollHint.classList.add('on-main-menu');
    scrollHint.classList.remove('hidden');
  }
  // Restore the wallet pill only if WE hid it (preserves the logged-out
  // state where it stays display:none).
  if (userProfile && userProfile.dataset.hiddenForGameplay === '1') {
    userProfile.style.display = 'block';
    delete userProfile.dataset.hiddenForGameplay;
  }
  document.documentElement.style.overflow = '';
  document.body.style.overflow = '';
  document.body.style.height = '';
}
